const ArchivedDataUploadApiUrls = {
  ACE_HIGHWAY: ` ${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/data-restore/upload`,
  ACE_OCEAN: ` ${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/data-restore/upload`,
  ACI_OCEAN: ` ${process.env.REACT_APP_USER_ACI_OCEAN_URL}/aci-ocean/data-restore/upload`,
  AES: ` ${process.env.REACT_APP_USER_AES_URL}/aes/data-restore/upload`,
  ACI_HIGHWAY: ` ${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/data-restore/upload`,
  SHARED: ` ${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/data-restore/upload`,
  EHBL: ` ${process.env.REACT_APP_USER_EHBL_URL}/ehbl/data-restore/upload`,
  ACE_ISF: ` ${process.env.REACT_APP_USER_ACE_ISF_URL}/ace-isf/data-restore/upload`,
  ACI_AIR: ` ${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/data-restore/upload`,
  FDA_PN: ` ${process.env.REACT_APP_USER_FDA_PN_URL}/fda-pn/data-restore/upload`,
  SUBMIT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/data-restore/submit`,
  GET_TPR_USER: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/get`,
  GET_TPR_USER_PREFERENCE: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user-preference/get`,
  GET_TPR_USER_DETAILS: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/detail/get`
};
  
  export default ArchivedDataUploadApiUrls
  